import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { buildQueryParams } from "@/shared/utils/utils";

interface Recovery {
  id: number;
  name: string;
  branch_id?: number | null;
}

type NewRecovery = Omit<Recovery, "id">;

export const recoveryApi = api
  .enhanceEndpoints({
    addTagTypes: ["recoveryAppi", "recoveryOld", "ticket"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      getAllRecovery: builder.query({
        query: (params) => ({
          url: `recovery/get-recent-delayed-users`,
          method: RequestMethod.GET,
          params: buildQueryParams(params),
        }),
        providesTags: ["recoveryAppi"],
      }),

      getAllRecoveryOld: builder.query({
        query: (params) => ({
          url: `recovery/get-old-inactive-users`,
          method: RequestMethod.GET,
          params: buildQueryParams(params),
        }),
        providesTags: ["recoveryOld"],
      }),
      //recovery/update-ticket
      updateTicket: builder.mutation({
        query: (ticketData) => ({
          url: "/recovery/update-ticket",
          method: RequestMethod.POST,
          body: ticketData,
        }),
        invalidatesTags: ["recoveryAppi", "recoveryOld", "ticket"],
      }),

      recoveryExport: builder.mutation({
        query: (catchmentRequest) => {
          return {
            url: `admin/catchment/export`,
            method: "POST",
            body: {
              ...catchmentRequest,
            },
            responseHandler: (response) => response.blob(), // Maneja la respuesta como un blob
          };
        },
      }),
      /* This fn `getUserMarketingTags` is used to get userTags & marketingTags  */
      getUserMarketingTags: builder.query({
        query: () => {
          return {
            url: `/recovery/tags-marketing`,
            method: RequestMethod.GET,
          };
        },
      }),

      getRecoveryCounts: builder.query({
        query: () => {
          return {
            url: `recovery/counts`,
            method: RequestMethod.GET,
          };
        },
      }),
    }),
  });

export const {
  useGetAllRecoveryQuery,
  useGetAllRecoveryOldQuery,
  useUpdateTicketMutation,
  useRecoveryExportMutation,

  useGetUserMarketingTagsQuery,
  useGetRecoveryCountsQuery,
} = recoveryApi;
